import { academyProgramEndpoint } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentProgram(
  programId: number | null | undefined | string
) {
  const query = useQuery({
    queryKey: ["academy", "program", programId],
    queryFn: async () => {
      if (!programId) return null;
      const res = await axiosInstance.get(
        `${academyProgramEndpoint}/${programId}`
      );
      return res.data?.program ?? res.data ?? null;
    },
    enabled: !!programId,
  });

  return {
    program: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
